module.exports = __webpack_public_path__ + "static/bryan-ruef-2-ee61a78e2de9e4d1d33e2bb9631a8e51.jpg";